import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Drawer, IconButton } from "@mui/material";
import { useRouter } from "next/router";
import { useState } from "react";
import { useSelector } from "react-redux";

import { signOutUser } from "../../firebase/authentication";
import { theme } from "../../mui-customs/Theme";
import resetReduxState from "../../redux/resetReduxState";
import { RootState } from "../../redux/store";
import Button from "../Button";

interface MenuDrawerProps {
  openState: boolean;
  handleClose: () => void;
}

const MenuDrawer = ({ openState, handleClose }: MenuDrawerProps) => {
  const router = useRouter();
  const userUid = useSelector((state: RootState) => state.user.user.uid);
  const [isSignOutButtonLoading, setIsSignOutButtonLoading] = useState(false);
  const handleSignOut = async () => {
    setIsSignOutButtonLoading(true);
    await signOutUser();
    resetReduxState();
    handleClose();
    setIsSignOutButtonLoading(false);
    localStorage.removeItem("admin-proxy-login");
    router.replace("/auth/login");
  };
  return (
    <Drawer
      anchor="right"
      open={openState}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "400px",
          p: 3,
        },
      }}
    >
      <Box sx={{ width: "100%", display: "flex", mb: 3 }}>
        <IconButton
          onClick={handleClose}
          sx={{ width: "50px", height: "50px", ml: "auto" }}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Button
          disabled={Boolean(userUid)}
          onClick={() => {
            router.push("/auth/login");
          }}
        >
          Login
        </Button>
        <Button
          disabled={Boolean(userUid)}
          onClick={() => {
            router.push("/auth/sign-up");
          }}
        >
          Sign up
        </Button>
        <Button
          loading={isSignOutButtonLoading}
          disabled={!Boolean(userUid)}
          onClick={handleSignOut}
          sx={{ backgroundColor: theme.brand2[900] }}
        >
          Sign Out
        </Button>
      </Box>
    </Drawer>
  );
};

export default MenuDrawer;
